(function() {

	angular
		.module('ngmvac')
		.controller('contentController', contentController);

		contentController.$inject = ['$window', '$filter', 'ReservationFactory', 'HotelFactory', 'ContentApiService', 'timeService'];

		function contentController($window, $filter, ReservationFactory, HotelFactory, ContentApiService, timeService) {
            var vm = this;
            vm.countries = [];
            vm.destinos  = [];
            vm.showModal = false;
            vm.showModalHotel = false;
            vm.contentView = "/hotelesView";
            vm.enbd=0;
            vm.enhotelbeds=0;

            HotelFactory.getCountries().then(function(response){
               
                if(response.data.length > 0){
                    vm.countries = response.data;
                }
            });

            vm.hotelsView = function(){
                vm.contentView = "/hotelesView";
            }

            vm.contentDownloadZonas = function(step)
            {
                if(step==1)
                {
                    $inicio=0;
                    $fin=0;
                    $finhb=0;

                    swal({
                          title: "Cargando...",
                          text: "",
                          showConfirmButton: false
                          
                        });

                      HotelFactory.getUpdatezonas($inicio, $fin).then(function(response)
                      {
                         vm.enbd=response.data.totalbd;
                         vm.enhotelbeds=response.data.totalzonas;
                         $finhb=response.data.totalzonas;
                         swal.close();
                      });
                }
                else
                {
                      HotelFactory.getUpdatezonas($inicio, $finhb).then(function(response)
                      {
                         vm.enbd=response.data.totalbd;
                         vm.enhotelbeds=response.data.totalzonas;
                         swal.close();
                      });
                }
            }

            vm.destinosView = function(){
                HotelFactory.getAllDestinos().then(function(response){
                    if( response.data.length > 0 ){
                        vm.listaDestinos = response.data;
                    }
                });
                vm.contentView = "/destinosView";
            }

            vm.zonasView = function(){
                vm.contentView = "/zonasView";
                vm.contentDownloadZonas(1);
            }
             vm.updatepaises = function(){

                  swal({ 
                    title: "Descargando...",
                    type: "info",
                    showConfirmButton: false,
                    allowEscapeKey: false
                });
               
               HotelFactory.getUpdatepaises().then(function(response){

                   console.log(response.data);

                     swal({
                          title: "Se descargaron :"+response.data.agregados+" paises"+response.data.idiomas+" idiomas"+response.data.facility+" facilidades",
                          text: "",
                          type: "info",
                          closeOnConfirm: false
                        },
                        function(){
                            if(response.data!="0")
                            {
                              location.reload();
                            }
                            else
                            {
                               swal.close();
                            }
                        });



                });
            }

            vm.showModal_ = function(pais){

                var params = {
                    params : {countryCode : pais.code}
                }

                vm.selectedCountry = pais;

                HotelFactory.getDestinos(params).then(function(response){
                    console.log(response, "response->");
                    if(response.data.length > 0){
                        vm.destinos = response.data;
                    }
                });

                vm.showModal = !vm.showModal;
            }

            vm.showModalHotels = function(destino){
                
                var param = {
                    params : {
                        destinyId : destino.id
                    }
                }
                console.log(param, "param->");
                HotelFactory.getHotelsByDestiny(param).then(function(response){
                    if(response.data.length > 0){
                        vm.hoteles = response.data;
                    }
                    console.log(response, "response->>>><");
                });

                vm.showModalHotel = !vm.showModalHotel;
            }

            vm.minimizeModalHotels = function(){
                console.log("function executed");
                $('#hotels-modal').on('hide.bs.modal', function () {
                    console.log("jsdnjsnsjnsdjns");
                $('#hotels-modal').removeData();
                })
                                // $('#hotels-modal').modal('hide');  
            }

            vm.contentDownload = function(pais){

                var params = {
                    params : {
                        countryCode : pais.code,
                        destinationCode : 0,
                        from        : parseInt($("#countryInicio_" + pais.code).val()),
                        to          : parseInt($("#countryFin_" + pais.code).val())
                    }
                }
                
                swal({ 
                    title: "Descargando...",
                    type: "info",
                    showConfirmButton: false,
                    allowEscapeKey: false
                });
	
                HotelFactory.contentDownload(params).then(function(response){

                   
                    
                    if(parseInt(response.data.inserciones) > 0){
                        
                        swal({ 
                            title: "Se descargaron " + response.data.inserciones + " hoteles ",
                            type: "info",
                            showConfirmButton: true,
                            allowEscapeKey: false
                        });

                        angular.forEach(vm.countries, function(country){
                            if(pais.code == country.code){
                                country.total_hoteles   = response.data.inserciones;
                                country.total           = country.total + response.data.inserciones;
                            }
                        });


                    }else{

                        swal({ 
                            title: "Se descargaron 0 hoteles de la API",
                            type: "warning",
                            showConfirmButton: true,
                            allowEscapeKey: false
                        });
                    }
                    
                });
            }

            vm.contentDownloadDestinos = function(destino){
                var params = {
                    params : {
                        countryCode : vm.selectedCountry.code,
                        destinationCode : destino.code,
                        from : parseInt($("#destinoInicio_" + destino.code).val()),
                        to   : parseInt($("#destinoFin_" + destino.code).val())
                    }
                }
                
                swal({
                    title: "Descargando...",
                    type : "info",
                    showConfirmButton : false,
                    allowEscapeKey : false
                });

                HotelFactory.contentDownload(params).then(function(response){

                    if(response.data.total > 0){
                        
                        swal({ 
                            title: "Se descargaron " + response.data.inserciones + " hoteles en " + destino.name,
                            type: "info",
                            showConfirmButton: true,
                            allowEscapeKey: false
                        });

                        angular.forEach(vm.destinos, function(destino_){
                            if(destino.code == destino_.code){
                                destino_.total_hoteles = response.data.total;
                                destino_.total = destino_.total + response.data.inserciones;
                            }
                        });

                        // swal.close();
                    }else{
                        swal({ 
                            title: "Se descargaron 0 hoteles de la API" ,
                            type: "warning",
                            showConfirmButton: true,
                            allowEscapeKey: false
                        });
                    }
                });
            }
        }
        
})();
